import alerts from './alerts'
import auth from './auth'
import graphs from './graphs'
import notifications from './notifications'
import observations from './observations'
import userGroups from './userGroups'
import users from './users'

export default { alerts, auth, graphs, notifications, observations, userGroups, users }
